import { serviceRequest } from 'utils/http';
import {
  InvestigatorService,
  MultipleInvestigatorNotificationUpdateDto,
} from 'common/api';

export function updateInvestigatorNotificationAPI(
  multipleInvestigatorNotificationUpdateDto: MultipleInvestigatorNotificationUpdateDto
) {
  return serviceRequest(() =>
    InvestigatorService.investigatorControllerUpdateInvestigatorNotifications(
      multipleInvestigatorNotificationUpdateDto
    )
  );
}
